module.exports = __webpack_public_path__ + "img/announcment.1137824f.png";